<template lang="html">
  <transition-group name="flip-grid" tag="div"
  class="floorplan-grid row no-gutters" ref="grid">
    <router-link v-for="floorplan in floorplanList"
    tag="div"
    :key="floorplan.id"
    :to="{ name: 'FloorplanDetail', params: { id: floorplan.id }}"
    class="floorplan-grid-tile-link flip-grid-item
    col-lg-4 col-12 p-lg-1 p-0 pt-1">
      <floorplan-grid-tile
      :floorplan="floorplan"
      :selectLabel="'DETAILS'"
      class="grid-tile" />
    </router-link>
  </transition-group>
</template>

<script>
import FloorplanGridTileComponent from '@/components/Floorplan/FloorplanGridTile';

export default {
  props: {
    floorplanList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    scrollTo(element, to, duration) {
      if (duration <= 0) return;
      const difference = to - element.scrollTop;
      const perTick = difference / duration * 10;

      setTimeout(() => {
        element.scrollTop += perTick;
        if (element.scrollTop === to) return;
        this.scrollTo(element, to, duration - 10);
      }, 10, this);
    }
  },
  watch: {
    floorplanList() {
      this.scrollTo(this.$refs.grid.$el.parentElement, 0, 200);
    }
  },
  components: {
    'floorplan-grid-tile': FloorplanGridTileComponent
  },
};
</script>

<style lang="scss" scoped>
.floorplan-grid {
  // background: black;
}

.floorplan-grid-tile-link {
  @media screen and (min-width: $breakpoint-lg) {
    // &:nth-child(even) {
    //   padding-right: 0 !important;
    // }
    // &:nth-child(odd) {
    //   padding-left: 0 !important;
    // }
  }
}

.grid-tile {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Floorplan/FloorplanGrid.vue